import AdminClient from '@avcan/utils/api/clients/admin'
import * as Config from './config'
import * as Auth from 'contexts/authentication'
import useSWRImmutable from 'swr/immutable'

const client = new AdminClient(Config.api, Config.key)

export default client

export function useUserInfo() {
    const { getAccessTokenSilently, isAuthenticated } = Auth.useAuth()
    const key = isAuthenticated ? 'user' : null

    return useSWRImmutable(key, () => client.getUserInfo(getAccessTokenSilently))
}

export function useUsers(username, page) {
    const { isAuthenticated, getAccessTokenSilently } = Auth.useAuth()
    const key = isAuthenticated ? ['users', username, page] : null

    return useSWRImmutable(key, () => client.getUsers(username, page, getAccessTokenSilently))
}
